"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Period = _interopRequireDefault(require("./Period"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class WorkingTime {
  constructor() {
    _defineProperty(this, "periods", []);
  }

  static fromObject(obj) {
    let w = new WorkingTime();

    if (Array.isArray(obj)) {
      w.periods = obj.map(period => _Period.default.fromObject(period));
      return w;
    }

    Object.keys(obj || {}).forEach(key => {
      let value = obj[key];

      switch (key) {
        case 'periods':
          w.periods = value.map(period => _Period.default.fromObject(period));
          break;
      }
    });
    return w;
  }

  getWorkingTimeOfDay(weekDay) {
    let w = new WorkingTime();
    w.periods = this.periods.map(item => {
      return _Period.default.fromObject({
        period: item.period,
        days: item.days.filter(day => day.weeknum == weekDay)
      });
    });
    return w;
  }

  isOpen(date = null) {
    const todayDate = date || this.getBRLNowTime();
    const weekDay = todayDate.getDay();
    const nowTime = `${String(todayDate.getHours()).padStart(2, `0`)}${String(todayDate.getMinutes()).padStart(2, `0`)}`;
    const horaries = this.periods[0].days;
    const todayNum = (weekDay + 6) % 7;
    const yesterdayNum = todayNum == 0 ? 6 : todayNum - 1;
    const tomorrowNum = (weekDay + 1) % 7;

    const stringTime2Int = time => {
      return +time.replace(':', '');
    };

    if (!horaries || !horaries[todayNum]) {
      return false;
    }

    const today = horaries[todayNum];
    const yesterday = horaries[yesterdayNum];

    if (!today.active) {
      return false;
    }

    if (yesterday.active) {
      const yesterdayPeriods = yesterday.open.map((openTime, openIndex) => {
        return {
          active: yesterday.active,
          open: openTime,
          close: yesterday.close[openIndex],
          nextDay: stringTime2Int(openTime) >= stringTime2Int(yesterday.close[openIndex])
        };
      });
      const yesterdayNextDay = yesterdayPeriods.filter(d => d.nextDay);

      if (yesterdayNextDay.length > 0) {
        today.open.push('0000');
        today.close.push(yesterdayNextDay[0].close);
      }
    }

    for (let periodIndex = 0; periodIndex < today.open.length; periodIndex++) {
      const open = stringTime2Int(today.open[periodIndex]);
      const close = stringTime2Int(today.close[periodIndex]); //Se o periodo verificado passa para o próximo dia, ver somente se o horário de abertura é menor que o horário atual.
      //caso seja 00:00 no dia anterior, o horário de fechamento é o horário de abertura do dia atual.

      const tomorrow = horaries[tomorrowNum].open;

      if (open >= close && nowTime >= open && close <= tomorrow) {
        return true;
      } //Verificar se o horário atual está dentro do range


      if (nowTime >= open && nowTime <= close) {
        return true;
      }
    }

    return false;
  }

  static getWeekDays(locale = 'pt-br') {
    var baseDate = new Date(Date.UTC(2017, 0, 1));
    return Array(7).fill(0).map(() => {
      let dayName = baseDate.toLocaleDateString(locale, {
        weekday: 'long',
        timeZone: 'UTC'
      });
      baseDate.setDate(baseDate.getDate() + 1);
      return dayName;
    });
  }

  static getTemplatePeriodWeek(periodName = null) {
    return new _Period.default(periodName, Array(7).fill(0).map((item, index) => {
      return new Day(index + 1, null, null, true);
    }));
  }

  getBRLNowTime() {
    let now = new Date();
    now.setUTCHours(now.getUTCHours() - 3);
    return now;
  }

}

exports.default = WorkingTime;